import React from 'react'

const Pdf = () => {
  return (
    <svg
      fill='none'
      height='26'
      viewBox='0 0 22 26'
      width='22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5 24.5a1 1 0 001-1V7.473A5.975 5.975 0 0014.525 1.5H2.5a1 1 0 00-1 1v21a1 1 0 001 1h17z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M15.5 1.579V5.5a1 1 0 001 1h3.92M7.479 16a1.5 1.5 0 01-1.5 1.5h-1.5v-3h1.5a1.5 1.5 0 011.5 1.5zM4.479 20.499v-3M9.479 14.5a3 3 0 010 6v-6zM14.479 20.5v-5a1 1 0 011-1h2M14.479 17.499h2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Pdf
